import { render } from "./animatePage.vue?vue&type=template&id=34dbfdf4"
import script from "./animatePage.vue?vue&type=script&lang=js"
export * from "./animatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__